// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hwjnhvbrkvzumzhakgla.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh3am5odmJya3Z6dW16aGFrZ2xhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIzNDc0OTMsImV4cCI6MjA2NzkyMzQ5M30.RX_d4clsbfBKTdydWDncItpZ2okA38vLJg74xfybfdA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage, // Use localStorage for better session persistence
    persistSession: true,  // Persist session to prevent unexpected logouts
    autoRefreshToken: true,
  }
});

// Global error handler for 401/403 errors
let isHandlingAuthError = false;

supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'TOKEN_REFRESHED' && !session) {
    console.error('Global: Token refresh failed - triggering cleanup');
    handleAuthError();
  }
});

// Monitor REST API responses for auth errors
const originalFrom = supabase.from.bind(supabase);
supabase.from = (table: any) => {
  const query = originalFrom(table);
  const originalThen = query.then?.bind(query);
  
  if (originalThen) {
    query.then = function(onFulfilled: any, onRejected: any) {
      return originalThen(
        (response: any) => {
          // Check for 401/403 errors in response
          if (response?.error) {
            const status = response.error.code;
            if (status === '401' || status === '403' || 
                response.error.message?.includes('JWT') ||
                response.error.message?.includes('token')) {
              console.error('Global: Auth error detected in API response', response.error);
              handleAuthError();
            }
          }
          return onFulfilled ? onFulfilled(response) : response;
        },
        onRejected
      );
    };
  }
  
  return query;
};

function handleAuthError() {
  // Prevent race condition with flag
  if (isHandlingAuthError) return;
  isHandlingAuthError = true;
  
  // Clear all auth-related storage
  localStorage.removeItem('sb-hwjnhvbrkvzumzhakgla-auth-token');
  localStorage.removeItem('vivu_sidebar_permissions');
  
  // Redirect directly without calling signOut (which could trigger more errors)
  if (typeof window !== 'undefined' && !window.location.pathname.includes('/auth')) {
    window.location.href = '/#auth';
  }
}